import React from 'react';
import listQuery from '../../../graphql/queries/company/IsoCurrencyListQuery.graphql';
import { IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { IIsoCurrency } from '../../schema/p4types';

const IsoCurrencyOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: IIsoCurrency }) => {
  return (
    <span>
      {option.codeAlpha3} {option.name}
    </span>
  );
};

const IsoCurrency = {
  type: 'IsoCurrency',
  title: 'ISO Currency Codes',
  formTitle: 'ISO Currency Code',
  formUrl: null,
  workspaceUrl: null,
  instance: null,
  workspace: null,
  update: null,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'codeAlpha3',
    optionRenderer: IsoCurrencyOptionRenderer,
  },
};

export default IsoCurrency;
